export default "__VITE_ASSET__M4H48Wqz__"